import { FileText, FolderOpen, Share2 } from 'lucide-react';

import { FilesRootLayout } from './_components/_layouts/FilesRootLayout';
import { FilesExplorerView } from './_components/explorer/_FilesExplorerView';
import { FileDetailsView } from './_components/file-details/_FileDetailsView';
import { SharedFilesView } from './_components/shared-files/_SharedFilesView';
import { filesRoutes } from './routes';

import { createAppModule } from '~/shared/routing/createAppModule';
import { createModuleNav } from '~/shared/routing/createModuleNav';
import { createModuleRoutes } from '~/shared/routing/createModuleRoutes';

const routesDefinitions = createModuleRoutes({
  root: {
    path: filesRoutes.root,
    label: (t) => t.menu.files.root,
    icon: FolderOpen,
    // no component -> redirects to first child
  },
  explorer: {
    path: filesRoutes.explorer,
    label: (t) => t.menu.files.explorer,
    icon: FolderOpen,
    component: FilesExplorerView,
    requiredPermission: 'fileRead',
  },
  details: {
    path: filesRoutes.details,
    // no label -> hidden
    icon: FileText,
    component: FileDetailsView,
  },
  shared: {
    path: filesRoutes.shared,
    label: (t) => t.menu.files.shared,
    icon: Share2,
    component: SharedFilesView,
    requiredPermission: 'fileRead',
  },
});

// prettier-ignore
const filesNav = createModuleNav(($) =>
  $(routesDefinitions.root, [
    $(routesDefinitions.explorer), 
    $(routesDefinitions.details),
    $(routesDefinitions.shared)
  ]),
);

export const filesModule = createAppModule({
  routes: routesDefinitions,
  nav: filesNav,
  layout: FilesRootLayout,
});
